import { IconButton, Stack } from '@figma/fpl-components';
import { Icon24LogoWeavy } from '@figma/fpl-icons';
import { color, spacer } from '@figma/fpl-tokens/tokens.stylex';
import * as stylex from '@stylexjs/stylex';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TOOLKIT_PATH } from '@/components/Dashboard/enums/shared';
import { WorkflowCreditsDisplay } from '@/components/Recipe/FlowComponents/WorkflowRightToolbar/WorkflowCreditsDisplay';
import { I18N_KEYS } from '@/language/keys';

/** Top bar of the generate page: a button back to the Toolkit on the left and, for signed-in users, the credits balance. */
export function GenerateHeader({ signedIn }: { signedIn: boolean }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Stack.Row {...stylex.props(styles.root)} justify="space-between" gap={4}>
      <IconButton aria-label={t(I18N_KEYS.NAVIGATION_DRAWER.TOOLKIT)} onClick={() => navigate(TOOLKIT_PATH)}>
        <Icon24LogoWeavy />
      </IconButton>
      {signedIn && <WorkflowCreditsDisplay showCreditsLabel />}
    </Stack.Row>
  );
}

const styles = stylex.create({
  root: {
    flexShrink: 0,
    boxSizing: 'border-box',
    paddingBlock: spacer.spacer8px,
    paddingInline: spacer.spacer12px,
    backgroundColor: color.bg,
    color: color.text,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: color.border,
  },
});
